<template>
  <div class="error">
    <div class="header">
      <span>操作用户</span>
      <span>操作</span>
      <span>状态</span>
      <span>时间</span>
    </div>
    <div class="body">
      <van-pull-refresh
        class="pull-refresh"
        v-model="freshLoading"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="list"
          :immediate-check="false"
        >
          <div class="van-clearfix">
            <div class="item" v-for="(item, index) in list" :key="index">
              <span>{{ item.userName }}</span>
              <span>{{ item.stt === 1 ? "开" : "关" }}</span>
              <span>{{ item.status === 1 ? "成功" : "失败" }}</span>
              <span>{{ item.cdate }}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      page: 1,
      pageSize: 10,
      pages: 1,
      loading: false,
      freshLoading: false,
      finished: false,
      list: []
    };
  },

  async created() {
    const id = this.$route.query.id;
    this.id = id;
    this.onRefresh();
  },

  methods: {
    async getHistory() {
      const { id, page, pageSize } = this;
      await this.$api
        .getSwitchActionHistory({
          valveId: Number(this.id), //“阀门 ID”
          status: 2, //“1-成功;2-失败”,
          page,
          pageSize
        })
        .then(res => {
          if (res.errcode === 0 && res.list && res.list.length) {
            this.list = this.list.concat(res.list);
            this.pages = res.pages;
          } else {
            this.list = this.list.concat([]);
          }
          this.page++;
        });
    },

    async onRefresh() {
      console.log("下拉");

      this.page = 1;
      this.freshLoading = true;
      this.list = [];
      await this.onLoad();
      this.freshLoading = false;
    },

    async onLoad() {
      console.log("下滑:", this.page);
      this.loading = true;
      if (this.page > this.pages) {
        this.loading = false;
        return false;
      }

      if (this.page === 1) {
        await this.getHistory();
      } else {
        this.page <= this.pages && (await this.getHistory());
      }

      this.loading = false;

      if (this.page > this.pages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    }
  }
};
</script>

<style lang="scss">
.error {
  height: 100%;
  font-size: 14px;
}

.header {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
}

.body {
  height: calc(100% - 40px);
}

.pull-refresh {
  height: 100%;
}

.list {
  height: 100%;
  overflow-y: scroll;
}

.header,
.item {
  display: flex;
  justify-content: center;

  span {
    flex: 1;
    text-align: center;

    &:last-child {
      flex: 2;
    }
  }
}

.item {
  margin-bottom: 10px;
}
</style>
